import { FuelRating, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { DS_TOKENS } from 'constants/styled.contants';
import { IEvaluation } from 'interfaces/profile.interface';
import React, { FC } from 'react';
import GenericEmptyState from '../GenericEmptyState';
import { Tags } from './Tags';

export const Rating: FC<IEvaluation> = ({ attributes, grade, total }) => (
  <FuelFlex
    defaultProps={{
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 'km6',
      customPadding: `${DS_TOKENS.spacing.km4} ${DS_TOKENS.spacing.km8}`,
    }}
  >
    <FuelTypography size="heading-sm" weight="bold" color="neutral-strong" data-testid="rating-title">
      Avaliação
    </FuelTypography>

    {grade ? (
      <FuelFlex
        defaultProps={{ gap: 'km4' }}
        smProps={{ flexDirection: 'column', alignItems: 'flex-start', gap: 'km6' }}
      >
        <FuelFlex
          defaultProps={{
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: 'km2',
            minWidth: '90px',
          }}
        >
          <FuelTypography size="display-lg" weight="bold" color="neutral-strong">
            {grade}
          </FuelTypography>
          <FuelRating readonly rating={grade} size="small" />
          <FuelTypography size="caption" weight="medium" color="neutral-default">
            {total} avaliações
          </FuelTypography>
        </FuelFlex>
        <Tags list={attributes} />
      </FuelFlex>
    ) : (
      <GenericEmptyState textContent="Ainda não possui avaliação na Fretebras." />
    )}
  </FuelFlex>
);
